export default __webpack_public_path__ + "static/media/emptybox.9d8e467b.svg";